import RowCell from 'components/Grids/DataGrid/Cells/RowCell';
import { appReactMemo } from 'hocs';
import { useGetDictionaryNaming } from 'hooks/useGetDictionaryNaming';

import { DICTIONARY_NAME_BY_DATA_KEY } from './sharedRenderers';
import { IDictionaryCellProps } from './types';

const DictionaryCell = ({ dataKey, item, ...rest }: IDictionaryCellProps) => {
  const getDictionaryNaming = useGetDictionaryNaming();

  return (
    <RowCell {...rest} dataKey={dataKey} item={item}>
      {getDictionaryNaming(DICTIONARY_NAME_BY_DATA_KEY[dataKey], item[dataKey])}
    </RowCell>
  );
};

export default appReactMemo(DictionaryCell);
